import CreateAccountModal from "./account-modal.component";

export default CreateAccountModal;
